import createIcon from '../../createIcon';

/**
 * @component @name TextRotateVertical
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNUgxNC41TDkuNzUgMTZIMTEuODVMMTIuNzUgMTMuOEgxNy43NUwxOC42NSAxNkgyMC43NUwxNiA1Wk0xMy4zOCAxMkwxNS4yNSA2Ljk4TDE3LjEyIDEySDEzLjM4Wk02LjI1IDE5Ljc1TDkuMjUgMTYuNzVINy4yNVY0LjI1SDUuMjVWMTYuNzVIMy4yNUw2LjI1IDE5Ljc1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextRotateVertical = createIcon('TextRotateVertical', [
  [
    'path',
    {
      d: 'M16 5H14.5L9.75 16H11.85L12.75 13.8H17.75L18.65 16H20.75L16 5ZM13.38 12L15.25 6.98L17.12 12H13.38ZM6.25 19.75L9.25 16.75H7.25V4.25H5.25V16.75H3.25L6.25 19.75Z',
      key: 'veqmzu',
    },
  ],
]);

export default TextRotateVertical;
